import qs from 'qs';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import mapValues from 'lodash/mapValues';
import transform from 'lodash/transform';
import isObjectLike from 'lodash/isObjectLike';
import isPlainObject from 'lodash/isPlainObject';

export function createQueryString(queryParams) {
  return qs.stringify(queryParams, {
    addQueryPrefix: false,
    arrayFormat: 'brackets',
    encodeValuesOnly: true,
  });
}

export function parseQueryString(queryString) {
  return qs.parse(queryString, {
    ignoreQueryPrefix: true,
  });
}

/**
 * Deeply remove empty items from an object, empty items are:
 * - Empty Array
 * - Empty Object
 * - Null or Undefined values
 * @param {Object} obj The object you wish to remove the empty items from
 * @returns {Object} The objects without items
 */
export function removeEmptyItems(obj) {
  function internalCleanup(obj) {
    return transform(
      obj,
      (result, value, key) => {
        const cleaned = isPlainObject(value) ? internalCleanup(value) : value;

        if (isNil(cleaned)) {
          return;
        }


        result[key] = cleaned;
      },
      {}
    );
  }

  return internalCleanup(obj);
}

export function convertEmptyValuesToNull(value) {
  const cleaned = isPlainObject(value)
    ? mapValues(value, convertEmptyValuesToNull)
    : value;

  if (isNil(cleaned) || (isObjectLike(cleaned) && isEmpty(cleaned))) {
    return null;
  }

  return cleaned;
}
